import { Stack, tokens, Text, Icon } from '@hotjar/hotsauce';
import type { EnhancedProduct } from '@hotjar/product-catalog';
import { ArrayTranslation, useTranslationWithPrefix } from '@hotjar/translations';
import styled from '@emotion/styled';

const S = {
  ProductTitle: styled(Text)`
    ${tokens.flexContainer('default', { gap: tokens.spacer.x1 })};
    align-items: center;
  `,
  ProductIcon: styled(Icon)<{ product: EnhancedProduct['name'] }>`
    width: ${tokens.spacer.x3};
    height: ${tokens.spacer.x3};
    color: ${(p) => (p.product === 'observe' ? '#C78312' : '#8363DF')};
  `,
  FeatureList: styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    margin-left: ${tokens.spacer.x4};
    gap: ${tokens.spacer.x1};
  `,
  Feature: styled.li`
    display: flex;
    gap: ${tokens.spacer.x1};
    align-items: center;
  `,
};

interface Props {
  product: EnhancedProduct['name'];
  plan: 'plus' | 'businessOrHigher';
}

export function MissingProductFeatures({ product, plan }: Props): JSX.Element {
  const { t: tProduct } = useTranslationWithPrefix('checkout:product-information.product');

  return (
    <Stack key={product} direction="column" spacing="x1">
      <S.ProductTitle textType="header5" as="h2">
        <S.ProductIcon product={product} icon={product === 'observe' ? 'hidden' : 'question'} />
        {tProduct(product)}
      </S.ProductTitle>

      <S.FeatureList>
        <ArrayTranslation
          i18nKey={`checkout:churn.deflection-modal.${product}.${plan}`}
          mapperFunction={(text: string) => (
            <S.Feature key={text}>
              <Icon icon="close" color="text_danger" />
              <Text as="span" textType="body2" textColor="text_light">
                {text}
              </Text>
            </S.Feature>
          )}
        />
      </S.FeatureList>
    </Stack>
  );
}
